import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";
import http from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clear the fragment from the URL immediately.
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await http.post("/auth/session", { session_id: sessionId }, { withCredentials: true });
        setUser(res.data);
        navigate("/admin", { state: { user: res.data } });
      } catch (e) {
        const status = e?.response?.status;
        if (status === 403) {
          setError("That Google account isn't authorized for BOSSY admin. Please use bossyroc@gmail.com.");
        } else {
          setError("Sign-in failed. Please try again.");
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center px-5">
        <div className="bg-white rounded-2xl border p-9 max-w-md text-center" style={{ borderColor: "var(--cream-dark)" }}>
          <AlertCircle size={40} className="text-orange mx-auto" />
          <p className="font-ui text-navy mt-4 leading-relaxed">{error}</p>
          <button onClick={() => navigate("/login")} className="mt-6 bg-navy text-cream px-6 py-3 rounded-full font-ui font-semibold hover:bg-orange transition-colors">
            Back to Sign In
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center">
      <Loader2 size={36} className="text-teal animate-spin" />
      <p className="font-ui text-navy/60 mt-4">Signing you in…</p>
    </div>
  );
}
